import { useMemo, useState } from "react";
import EvaluatePasswordPhrase from "../../../utils/auth/evaluatePasswordPhrase";
import { Icon } from "../../../components/icons/Icon";
import { eye, eyeOff } from "../../../components/icons/eye";
// import "../assets/styles/authentication.css";

export default function RegisterForm({ onSubmit, status = {}, disabled }) {
  const [name, setName] = useState("David BL");
  const [fax, setFax] = useState("");
  const [email, setEmail] = useState("davidbl@citywit.com");
  const [password, setPassword] = useState("David@Broderick70!");
  const [showPassword, setShowPassword] = useState(false);
  const [icon, setIcon] = useState(eyeOff);

  const passEvalResult = useMemo(
    () => EvaluatePasswordPhrase(password, { name, email }),
    [password, name, email]
  );

  const submit = (e) => {
    e.preventDefault();
    onSubmit({ name, fax, email, password });
  };

  const handlePasswordVisibilityToggle = (e) => {
    e.preventDefault();
    setShowPassword(!showPassword);
    setIcon((i) => (i === eye ? eyeOff : eye));
  };

  const passwordInputClasses = `form-control ${
    passEvalResult.strength === ""
      ? "border-light"
      : passEvalResult.strength === "Weak" && !passEvalResult.complete
      ? "border-danger"
      : passEvalResult.strength === "Weak" && passEvalResult.complete
      ? "is-invalid"
      : passEvalResult.strength === "Moderate" && !passEvalResult.complete
      ? "border-warning"
      : passEvalResult.strength === "Moderate" && passEvalResult.complete
      ? "border-warning"
      : passEvalResult.strength === "Strong" && !passEvalResult.complete
      ? "border-success"
      : passEvalResult.strength === "Strong" && passEvalResult.complete
      ? "border-success success bg-opacity-25"
      : "border-light"
  }`;

  return (
    <form onSubmit={submit} className="p-4 border rounded">
      <div
        className="tab-pane fade show active"
        id="pills-profile"
        role="tabpanel"
        aria-labelledby="pills-profile-tab"
      >
        <div className="form px-4">
          <input
            type="text"
            className="form-control"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <input
            type="text"
            name="fax"
            className="form-control fax"
            placeholder=""
            value={fax}
            onChange={(e) => setFax(e.target.value)}
            tabIndex="-1"
          />
          <input
            type="email"
            className="form-control mt-2"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <div className="password input-container">
            <input
              type={showPassword ? "text" : "password"}
              className={`${passwordInputClasses} mt-2`}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              aria-describedby="pw-help"
              required
            />
            {/* Use a button for accessibility */}
            <button
              type="button"
              onClick={handlePasswordVisibilityToggle}
              className="pw-display-toggle"
              aria-label={showPassword ? "Show password" : "Hide password"}
            >
              <Icon
                icon={icon}
                size={24}
                width={24}
                height={20}
                strokeWidth={2}
                fill="none"
                color={"#0969da"}
                className="pointer-events-none"
              />
            </button>
          </div>
          {/* strength meter */}
          <div className="mt-2" aria-live="polite">
            <div className="progress" style={{ height: 6 }}>
              <div
                className={`progress-bar bg-${passEvalResult.color}`}
                style={{ width: `${Math.max(0, passEvalResult.percent)}%` }}
                role="progressbar"
                aria-valuenow={passEvalResult.percent}
                aria-valuemin={0}
                aria-valuemax={100}
              />
            </div>
            <small
              id="pw-help"
              className={`d-block mt-1 text-${passEvalResult.color}`}
            >
              {passEvalResult.strength && !passEvalResult.isPassword
                ? `${passEvalResult.strength} passphrase`
                : passEvalResult.strength && passEvalResult.isPassword
                ? `${passEvalResult.strength} password`
                : "\u00A0"}
            </small>
            <ul className="pw-help small text-muted mb-0">
              {passEvalResult?.messages?.errors?.map((e) => (
                <li className="pw-hints" key={e}>
                  {e}
                </li>
              ))}
              {passEvalResult?.messages?.caution?.map((c) => (
                <li className="pw-hints" key={c}>
                  {c}
                </li>
              ))}
              {passEvalResult?.messages?.hints?.map((h) => (
                <li className="pw-hints" key={h}>
                  {h}
                </li>
              ))}
              {passEvalResult?.messages?.policiesMet?.map((m) => (
                <li className="pw-hints" key={m}>
                  {m}
                </li>
              ))}
              {passEvalResult?.messages?.needs?.map((n) => (
                <li className="pw-hints" key={n}>
                  {n}
                </li>
              ))}
            </ul>
          </div>

          <button
            className="submit btn w-100 mt-3"
            type="submit"
            disabled={disabled || status?.loading}
          >
            {status?.loading ? "Registering..." : "Register"}
          </button>

          {status?.error && <p className="text-danger mt-2">{status.error}</p>}
          {status?.success && (
            <div className="text-success mt-2">{status.success}</div>
          )}
        </div>
      </div>
    </form>
  );
}
